import { get, post, put } from '../../utils/http';

export const fetchIntegrations = ({ accountId }) => get(`/accounts/${accountId}/integrations`);

export const updateIntegrations = ({ accountId, integrationId, ...params }) =>
  put(`/accounts/${accountId}/integrations/${integrationId}`, params);

export const fetchGlobalPaymentsStores = ({ accountId, branchId, baseUrl, token }) =>
  post(`/accounts/${accountId}/integrations/global-payments/branches/${branchId}/stores`, { baseUrl, token });

export const fetchFortressSyncProjects = ({ accountId, integrationId, branchId }) =>
  get(`/accounts/${accountId}/integrations/${integrationId}/fortress/projects`, { branchId });

export const syncFortressProject = ({ accountId, integrationId, projectId }) =>
  post(`/accounts/${accountId}/integrations/${integrationId}/fortress/projects/${projectId}/sync`);
